/************************************
MODULE:         Resize
WHAT IT DOES:   Watches resize/orientation events and limits their frequency, saves some global parametrs used anywhere else (like window dimensions) to global vars
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {
    var resizeTimer,
        resized = false,
        cookieBar;

    function initResize() {
        setGlobalVars();
        $(window).on('resize', resizeProcessing);
        $(window).on('orientationchange', resizeProcessing);
        $(window).on('resize:now', resizeAfterProcessing.bind(window, false));
    }

    function resizeProcessing() {
        if (typeof resizeTimer != 'undefined')
            clearTimeout(resizeTimer);
        resized = true;
        resizeAfterProcessing();
    }

    function resizeAfterProcessing(notTrigger) {
        if (resized) {
            resized = false;
            resizeTimer = setTimeout(resizeAfterProcessing, 150);
        }
        else {
            var win = $(window),
                oldCookie = window.App.globals.cookieRealHeight,
                newWid = win.width(),
                newHei = win.height();
            updateCookie();
            if (newWid != window.App.globals.width || newHei != window.App.globals.height || oldCookie != window.App.globals.cookieRealHeight) {
                window.App.globals.width = newWid;
                window.App.globals.height = newHei;
                if (typeof Modernizr != 'undefined') {
                     window.App.globals.isSmallScreen = Modernizr.mq('only screen and (max-width:1200px)');
                     window.App.globals.isTabletSmall = Modernizr.mq('only screen and (max-width:1023px)');
                     window.App.globals.isMobileView = Modernizr.mq('only screen and (max-width:768px)');
                     window.App.globals.isMobileSmall = Modernizr.mq('only screen and (max-width:767px)');
                }
                if (typeof notTrigger != 'undefined' && notTrigger)
                    return;
                win.trigger('resize:finished');
            }
        }
    }

    function setGlobalVars() {
        window.App = window.App || {};
        window.App.globals = $.extend({}, window.App.globals, window.appState);
        window.App.globals.isMobile = $('html').hasClass('touch');
        window.App.globals.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        window.App.globals.isCustomScroll = window.App.globals.isIOS;
        window.App.globals.onScrollElement = App.globals.isCustomScroll ?  $('.js-main') :  $(window);
        window.App.globals.scrollElement = App.globals.isCustomScroll ?  $('.js-main') : $('html, body');
        window.App.globals.getTop = function() {
            return window.App.globals.isCustomScroll
                   ? window.App.globals.scrollElement[0].scrollTop
                   : Math.max(document.documentElement.scrollTop, document.body.scrollTop);
        };

        if (!(window.location.href.indexOf('safepay') > -1)) {
            $('html').addClass(window.App.globals.isCustomScroll ? 'custom-scroll' : 'no-custom-scroll');
        }
        


        cookieBar = $('.js-cookie-bar');
        updateCookie();

        resizeAfterProcessing(true);
    }

    function updateCookie() {
        window.App.globals.cookieHeight = cookieBar.length ? cookieBar.outerHeight() : 0;
        window.App.globals.cookieRealHeight = parseInt(cookieBar.css('bottom')) == 0 ? window.App.globals.cookieHeight : 0;
    }

    return {
        init: initResize
    };
}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.resize.js
 ** module id = 53
 ** module chunks = 24
 **/